import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../../service/modules/modules.component';
import { ServerService } from '../../../service/server/server.service';
import { HttpClient, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-user-detaile',
  templateUrl: './user-detaile.component.html',
  styleUrls: ['./user-detaile.component.scss']
})
export class UserDetaileComponent implements OnInit, OnDestroy {
  public isOnline: any;
  public loading = false;
  public subscription: Subscription | undefined;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any;
  lang: any;
  type_task: number | undefined;
  form1: FormGroup | any;
  user_info: any;
  user_id: number | any;
  logo_site: string | undefined;
  user_logo: string = this.serverService.get_default_user_logo();
  user_logo_bin: boolean = false;
  logo_info: any;

  national_id: number | undefined;
  economic_id: number | undefined;
  post_code: number | undefined;

  sign_logo: string = this.serverService.get_default_image();
  sign_logo_bin: boolean = false;
  sign_logo_info: any;

  id: number | undefined;
  i: number | undefined;
  code: number | undefined;
  title: string | undefined;
  search_array: any = [];

  creator: number | undefined;
  level: number | undefined;

  list_service: any = [];
  list_service_select: any = [];
  list_job: any = [];
  list_job_select: any = [];
  list_user_job: any = [];

  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , @Inject(MAT_DIALOG_DATA) private dialog_data: any, private dialog: MatDialog
    , private matDialogRef: MatDialogRef<UserDetaileComponent>) {
    this.server = this.serverService.get_server();
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.type_task = dialog_data.type_task;
      this.create_form1();
      this.id = dialog_data.id;
      this.title = dialog_data.title;
      this.code = dialog_data.code;
      this.i = dialog_data.i;
      if (this.type_task == 1) {
        this.check_access(5, 1);
        this.get_services();
        this.get_job();
      }
      if (this.type_task == 2) {
        this.check_access(4, 1);
      }
      if (this.type_task == 3) {
        this.form1.patchValue({
          title: dialog_data.search_array.title,
          group_title: dialog_data.search_array.group_title,
          group: dialog_data.search_array.group,
          sex_title: dialog_data.search_array.sex_title,
          sex: dialog_data.search_array.sex,
          cellphone: dialog_data.search_array.cellphone,
          phone: dialog_data.search_array.phone,
          user: dialog_data.search_array.user,
          email: dialog_data.search_array.email,
          site: dialog_data.search_array.site,
          address: dialog_data.search_array.address1,
          comment: dialog_data.search_array.comment,
          status_id: dialog_data.search_array.status_id,
          status_title: dialog_data.search_array.status_title,
          national_id: dialog_data.search_array.national_id,
          economic_id: dialog_data.search_array.economic_id,
          post_code: dialog_data.search_array.post_code,
        })
      }
    }
  }//end consructor

  ngOnInit() {
    this.server = this.serverService.get_server();
    this.lang = JSON.parse(<any>localStorage.getItem('lang'));
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }

  create_form1() {
    this.form1 = new FormGroup({
      'title': new FormControl(null),
      'sex_title': new FormControl(null),
      'sex': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'user': new FormControl(null),
      'email': new FormControl(null, [Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
      'cellphone': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'group': new FormControl(null),
      'group_title': new FormControl(null),
      'phone': new FormControl(null),
      'site': new FormControl(null),
      'status_id': new FormControl(null),
      'status_title': new FormControl(null),
      'address': new FormControl(''),
      'comment': new FormControl(null),
      'change_pass': new FormControl(null),
      'user_date': new FormControl(null),
      'password': new FormControl(null, [Validators.minLength(6)]),
      'national_id': new FormControl(null, [Validators.pattern('[0-9]{1,}'), Validators.minLength(11), Validators.maxLength(11)]),
      'economic_id': new FormControl(null, [Validators.pattern('[0-9]{1,}'), Validators.minLength(12), Validators.maxLength(12)]),
      'post_code': new FormControl(null, [Validators.pattern('[0-9]{1,}'), Validators.minLength(10), Validators.maxLength(10)]),
    });
    if (this.type_task == 1 || this.type_task == 2) {
      this.form1.controls['sex'].setValidators([Validators.required]);
      this.form1.controls['title'].setValidators([Validators.required]);
      this.form1.controls['cellphone'].setValidators([Validators.required]);
      this.form1.controls['group'].setValidators([Validators.required]);
      this.form1.controls['status_id'].setValidators([Validators.required]);
    }
  }

  check_access(type_task: any, excel: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1.valid && (this.type_task == 1 || this.type_task == 2)) {
      return false;
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: this.code }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.loading = false;
            this.level = res['level'];
            this.creator = res['creator'];
            if (type_task == 1) { this.insert(); }
            if (type_task == 2) { this.update(); }
            if (type_task == 3) { this.search(excel); }
            if (type_task == 4) { this.get_data(); }
            if (type_task == 5) {
              this.get_status();
              this.get_default_sex();
              this.get_default_group();
            }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  search(excel: number) {
    this.matDialogRef.close({
      title: this.form1.value.title,
      group_title: this.form1.value.group_title,
      group: this.form1.value.group,
      sex_title: this.form1.value.sex_title,
      sex: this.form1.value.sex,
      cellphone: this.form1.value.cellphone,
      phone: this.form1.value.phone,
      user: this.form1.value.user,
      email: this.form1.value.email,
      site: this.form1.value.site,
      address1: this.form1.value.address,
      comment: this.form1.value.comment,
      status_id: this.form1.value.status_id,
      status_title: this.form1.value.status_title,
      national_id: this.form1.value.national_id,
      economic_id: this.form1.value.economic_id,
      post_code: this.form1.value.post_code,
      export_excel: excel
    })
  }

  get_data() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10490, id: this.id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1.patchValue({
            'title': res['result'][0].user_title,
            'sex_title': res['result'][0].user_sex_title,
            'sex': res['result'][0].user_sex,
            'user': res['result'][0].user_userName,
            'cate': res['result'][0].user_cate,
            'email': res['result'][0].user_email,
            'cellphone': res['result'][0].user_cellPhone,
            'phone': res['result'][0].user_phone,
            'site': res['result'][0].user_site,
            'address': res['result'][0].user_address,
            'comment': res['result'][0].user_comment,
            'group': res['result'][0].user_group,
            'group_title': res['result'][0].user_groups_title,
            'status_id': res['result'][0].user_status,
            'status_title': res['result'][0].status_title,
            'password': res['result'][0].user_repassword,
            'national_id': res['result'][0].user_national_id,
            'economic_id': res['result'][0].user_economic_id,
            'post_code': res['result'][0].user_post_code,
          }
          );
          this.list_service_select = res['result'][0].user_services;
          this.list_job_select = res['result'][0].user_job;
          this.get_job();
          this.get_services();
          this.logo_info = {
            site: res['result'][0].user_logo_site,
            path: res['result'][0].user_logo
          }
          if (res['result'][0].user_logo) {
            this.user_logo = res['result'][0].user_logo_site + "/" + res['result'][0].user_logo;
            this.user_logo_bin = true;
          }
          else {
            this.user_logo = this.serverService.get_default_user_logo();
            this.user_logo_bin = false;
          }

          this.sign_logo_info = {
            site: res['result'][0].user_logo_site,
            path: res['result'][0].user_sign_logo
          }
          if (res['result'][0].user_sign_logo) {
            this.sign_logo = res['result'][0].user_logo_site + "/" + res['result'][0].user_sign_logo;
            this.sign_logo_bin = true;
          }
          else {
            this.sign_logo = this.serverService.get_default_image();
            this.sign_logo_bin = false;
          }

          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }
  //******************************************************************************************* */
  get_job() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var selected_array: any = [];
    if (this.list_job_select && this.type_task == 2) {
      selected_array = this.list_job_select.split(",").map((items) => {
        return parseInt(items);
      });
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10524 }).subscribe(
      (res: any) => {
        this.list_job = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            if (selected_array.indexOf(res['result'][i].site_job_id) != -1) {
              res['result'][i].checked = true;
            }
            this.list_job.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }
  //******************************************************************************************* */
  save() {
    if (this.type_task == 1) {
      this.insert();
    }
    else if (this.type_task == 2) {
      this.update();
    }
  }

  insert() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 10492, "user_id": this.user_id
      , 'title': this.form1.value.title
      , 'group': this.form1.value.group
      , 'sex': this.form1.value.sex
      , 'cellphone': this.form1.value.cellphone
      , 'status_id': this.form1.value.status_id
      , 'phone': this.form1.value.phone
      , 'sort': this.form1.value.sort
      , 'user': this.form1.value.user
      , 'email': this.form1.value.email
      , 'site': this.form1.value.site
      , 'comment': this.form1.value.comment
      , 'address1': this.form1.value.address
      , 'password': this.form1.value.password
      , 'logo_info': this.logo_info
      , 'logo_site': this.serverService.get_site()
      , 'list_service_select': this.list_service_select
      , 'list_job_select': this.list_job_select
      , 'national_id': this.form1.value.national_id
      , 'economic_id': this.form1.value.economic_id
      , 'post_code': this.form1.value.post_code

    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        //this.serverService.send_reception_repairman();
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0] }
          )
          this.serverService.send_group();
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "نام کاربری می بایست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end insert

  update() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 10493
      , "user_id": this.user_id
      , 'title': this.form1.value.title
      , 'group': this.form1.value.group
      , 'sex': this.form1.value.sex
      , 'cellphone': this.form1.value.cellphone
      , 'status_id': this.form1.value.status_id
      , 'phone': this.form1.value.phone
      , 'sort': this.form1.value.sort
      , 'user': this.form1.value.user
      , 'email': this.form1.value.email
      , 'site': this.form1.value.site
      , 'comment': this.form1.value.comment
      , 'address1': this.form1.value.address
      , 'password': this.form1.value.password
      , 'logo_info': this.logo_info
      , 'sign_info': this.sign_logo_info
      , 'logo_site': this.serverService.get_site()
      , 'id': this.id
      , 'list_service_select': this.list_service_select
      , 'list_job_select': this.list_job_select
      , 'national_id': this.form1.value.national_id
      , 'economic_id': this.form1.value.economic_id
      , 'post_code': this.form1.value.post_code

    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          //this.serverService.send_reception_repairman();
          this.matDialogRef.close(
            { result: res['result'][0], i: this.i }
          );
          this.serverService.send_group();
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "نام کاربری می بایست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end update


  get_services() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var selected_array: any = [];
    if (this.list_service_select && this.type_task == 2) {
      selected_array = this.list_service_select.split(",").map((items) => {
        return parseInt(items);
      });
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10495, user_id: this.user_id, software: this.serverService.get_software_id() }).subscribe(
      (res) => {
        this.list_service = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            if (selected_array.indexOf(res['result'][i].shop_services_id) != -1) {
              res['result'][i].checked = true;
            }
            this.list_service.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  change_select_service() {
    this.list_service_select = [];
    var service_array = <any>document.getElementsByName("service[]");
    for (var i = 0; i < service_array.length; i++) {
      if (service_array[i].checked == true) {
        this.list_service_select.push(service_array[i].value);
      }
    }
    this.list_service_select = this.list_service_select.map((items) => {
      return parseInt(items);
    });
  }


  change_job() {
    this.list_job_select = [];
    var job_array = <any>document.getElementsByName("job[]");
    for (var i = 0; i < job_array.length; i++) {
      if (job_array[i].checked == true) {
        this.list_job_select.push(job_array[i].value);
      }
    }
    this.list_job_select = this.list_job_select.map((items) => {
      return parseInt(items);
    });
  }


  change_avater(event: any) {
    var selectedFile = <File>event.target.files[0];
    var fd = new FormData();
    fd.append("image", selectedFile, selectedFile.name);
    this.serverService.post_address_file(this.server, "uploadImage", fd).subscribe(
      (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          ///this.uploadedAvaterProgess = (event.loaded / event.total) * 100;
        }
        else if (event.type === HttpEventType.Response) {
          var a = <any>event.body;
          this.user_logo = this.serverService.get_site() + "/" + this.serverService.get_path_upload_image() + a.result.filename;
          this.user_logo_bin = true;
          this.logo_info = {
            'site': this.serverService.get_site(),
            'path': this.serverService.get_path_upload_image() + a.result.filename
          }
        }
      }
    )
  }

  delete_logo() {
    this.user_logo = this.serverService.get_default_user_logo();
    this.user_logo_bin = false;
    this.logo_info = {
      path: '',
      site: ''
    }
  }
  //************************************************************************************************ */
  change_sign_logo(event: any) {
    var selectedFile = <File>event.target.files[0];
    var fd = new FormData();
    fd.append("image", selectedFile, selectedFile.name);
    this.serverService.post_address_file(this.server, "uploadImage", fd).subscribe(
      (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          ///this.uploadedAvaterProgess = (event.loaded / event.total) * 100;
        }
        else if (event.type === HttpEventType.Response) {
          var a = <any>event.body;
          this.sign_logo = this.serverService.get_site() + "/" + this.serverService.get_path_upload_image() + a.result.filename;
          this.sign_logo_bin = true;
          this.sign_logo_info = {
            'site': this.serverService.get_site(),
            'path': this.serverService.get_path_upload_image() + a.result.filename
          }
        }
      }
    )
  }

  delete_sign_logo() {
    this.sign_logo = this.serverService.get_default_image();
    this.sign_logo_bin = false;
    this.sign_logo_info = {
      path: '',
      site: ''
    }
  }
  //************************************************************************************************ */

  get_status() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1064 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1.patchValue({
            status_id: res['result'][0].status_id,
            status_title: res['result'][0].status_title,
          })
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_default_sex() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1733, creator: this.creator }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1.patchValue({
            sex: res['result'][0].user_sex_id,
            sex_title: res['result'][0].user_sex_title,
          })
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_default_group() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10491 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1.patchValue({
            group: res['result'][0].user_groups_id,
            group_title: res['result'][0].user_groups_title,
          })
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }



  load_services(id: number) {
    var where;
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      data: { id: id, where: where, creator: this.creator }
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          if (id == 23) {
            this.form1.patchValue({
              'group_title': result.title,
              'group': result.id
            })
          }
          if (id == 26) {
            this.form1.patchValue({
              'status_title': result.title,
              'status_id': result.id
            })
          }
          if (id == 214) {
            this.form1.patchValue({
              'sex_title': result.title,
              'sex': result.id
            })
          }
        }
      }
    )
  }

  reset_input(id: number) {
    if (id == 23) {
      this.form1.patchValue({
        'group_title': null,
        'group': null
      })
    }
    if (id == 26) {
      this.form1.patchValue({
        'status_title': null,
        'status_id': null
      })
    }
    if (id == 214) {
      this.form1.patchValue({
        'sex_title': null,
        'sex': null
      })
    }
  }


  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }

  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 8000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 8000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
